































import { Vue, Component, Prop, Watch, PropSync, Ref } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import { type EtiquetaDePrecoServiceAdapter } from '@/usecases'
import axios, { CancelTokenSource } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'

@Component
export default class SeletorDeTamanhosDeEtiqueta extends Vue {
	@Ref() campo!: HTMLInputElement
	@PropSync('value') selecionado?: TamanhoDaEtiqueta | string | null
	@Prop({ type: String }) idDoTamanhoSalvo!: string | null
	@Prop({ type: String }) grupoEconomicoId!: string | null

	@Inject('EtiquetaDePrecoServiceAdapter')
	private etiquetaDePrecoService!: EtiquetaDePrecoServiceAdapter

	tamanhos: TamanhoDaEtiqueta[] = []
	cancelToken: CancelTokenSource | null = null
	carregando = false

	created() {
		this.carregarTamanhosDoGrupo()
	}

	@Watch('grupoEconomicoId')
	onChangeGrupoEconomico() {
		this.carregarTamanhosDoGrupo()
	}

	async carregarTamanhosDoGrupo() {
		this.tamanhos = []
		if (!this.grupoEconomicoId) return

		try {
			this.carregando = true
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = { cancelToken: this.cancelToken.token }

			this.tamanhos = await this.etiquetaDePrecoService.findListaTamanhosDaEtiqueta(
				{ grupoEconomicoId: this.grupoEconomicoId },
				axiosConfig,
			)

			if (this.idDoTamanhoSalvo && !this.tamanhos.some(({ id }) => id === this.idDoTamanhoSalvo)) {
				const tamanhoSalvo = await this.etiquetaDePrecoService.findTamanhoEtiquetaById(this.idDoTamanhoSalvo, axiosConfig)
				if (tamanhoSalvo) this.tamanhos.unshift(tamanhoSalvo)
			}
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	adicionarTamanhoRecemCriado(tamanho: TamanhoDaEtiqueta) {
		if (this.tamanhos.some(({ id }) => tamanho.id === id)) return
		this.tamanhos.unshift(tamanho)
		this.selecionado = tamanho
	}

	get noDataMessage() {
		if (!this.grupoEconomicoId) {
			return 'Selecione um grupo econômico primeiro'
		}
		if (this.carregando) {
			return 'Carregando...'
		}
		return 'Nenhum tamanho cadastrado para este grupo econômico'
	}

	focus() {
		this.campo.focus()
	}

}
